<!-- 
  详情页 - 合同 回款计划
  props:
    id: 详情id
 -->

<template>
  <div class="v-tabs product-list">
    <div class="head">
      <div class="total">
        回款总金额：{{totalAmount}}{{Unit}}
      </div>
      <div class="inline-item" v-if="moduleName !== 'approvalApi'">
        <el-button size="small" type="primary" @click="addPayment">新建回款</el-button>
      </div>
    </div>
    <div class="content">
      <el-table
        :data="tableData"
        border
        highlight-current-row
        style="width: 100%"
        @click.native="tableClick">
        <el-table-column
          label="序号"
          type="index"
          width="50">
        </el-table-column>
        <el-table-column
          v-for="(head, index) in tableHead"
          :key="head.attr"
          :prop="head.attr"
          :label="head.attrName"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <!-- 详情页 -->
            <template v-if="head.attr === 'paymentNo'">
              <span v-if="!scope.row.result[index].popType">{{scope.row.result[index].attrValue}}</span>
              <a
                v-else
                data-type="detail"
                :data-id="scope.row.result[index].id"
                :data-popmodel="scope.row.result[index].popModel"
                :data-red="scope.row.result[index].isRed">
                {{scope.row.result[index].attrValue}}
              </a>
            </template>
            <!-- 图片 -->
            <template v-else-if="head.fieldType===5 || head.fieldType===6">
              <img
                class="imgWidth"
                data-type="img"
                :data-url="img"
                v-for="img in strToArr(scope.row.result[index].attrValue)"
                :key="img"
                :src="img"
                height="30">
            </template>
            <!-- 文件 -->
            <template v-else-if="head.fieldType===8">
              {{scope.row.result[index].attrValue | files}}
            </template>
            <template v-else-if="scope.row.result[index]">
              <span>{{scope.row.result[index].attrValue || (scope.row.result[index].attrValue === 0 ? 0 : '--')}}</span>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <!-- 新建回款 -->
    <add-payment
      v-if="paymentShow"
      ref="payment"
      :moduleName="'paymentApi'"
      :modal="false"
      :initData="initData"
      @closeDialog="paymentClose">
    </add-payment>
  </div>
</template>

<script>
import * as api from 'src/api'
import lightBox from 'src/plugins/lightbox'
import addPayment from 'components/modal/payment/add-payment'

export default {
  created () {
    this.getList()
  },
  props: {
    id: {
      type: Number
    },
    moduleName: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      tableHead: [],
      tableData: [],
      totalAmount: 0,
      paymentShow: false,
      initData: {},
      contractApprovelStatus: false // 如果是审批状态中，则禁止访问回款计划
    }
  },
  computed: {
    Unit () {
      if (this.tableData.length) {
        return this.tableData[0].unit
      } else {
        return '元'
      }
    }
  },
  methods: {
    getList () {
      let url = '/contractApi/getContractPayments.html'
      let params = {
        contractId: this.id
      }
      api.post(url, params, (data) => {
        this.tableHead = data.head
        this.tableData = data.result
        this.totalAmount = data.totalAmount
        this.contractApprovelStatus = data.contractApprovelStatus
      })
    },

    // 新建回款
    addPayment () {
      let url = 'paymentApi/getAssociatedCustomerAndContract.do'
      let params = {
        refType: this.moduleName.replace('Api', '') === 'approval' ? 'contract' : this.moduleName.replace('Api', ''),
        refId: this.id
      }
      api.post(url, params, (data) => {
        this.initData.customer = data.customer
        this.initData.contract = data.contract
        this.paymentShow = true
        this.$nextTick(() => {
          this.$refs.payment.dialogVisible = true
        })
      })
    },

    paymentClose () {
      this.paymentShow = false
      this.getList()
    },
    // 字符串转数组
    strToArr (str) {
      if (str) {
        return window.utils.json(str)
      } else {
        return []
      }
    },
    // 监听所有click事件
    tableClick (event) {
      // 获取目标元素或目标父元素的data属性集合
      let data = event.target.dataset
      let parent = event.target.parentNode && event.target.parentNode.dataset || '' // 如果parentNode不存在，则赋值为空字符串，避免为null
      // 如果存在type属性，则是一个可执行的事件
      if (data.type || parent.type && (data = parent)) {
        let id = Number(data.id)
        switch (data.type) {
          case 'img':
            lightBox(data.url)
            break
          // 查看详情
          case 'detail':
            this.$emit('openDetail', 'paymentApi', id)
            break
        }
      }
    }
  },
  components: {
    addPayment
  },
  filters: {
    files (str) {
      if (str) {
        str = window.utils.json(str)
      } else {
        str = []
      }
      if (str.length) {
        return str[0].filename || '--'
      } else {
        return '---'
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .imgWidth {
    max-width: 30px;
    margin-right: 10px;
  }
</style>


// WEBPACK FOOTER //
// payment-list.vue?29ae0eea